import { Trans } from "react-i18next";

import util from "utils/utils";

export default function groupJoinRequestedContent({ events, ownerGroup }) {
  return (
    <Trans
      i18nKey="notifications.groupJoinRequested"
      values={{
        name: util.getEventNames(events),
        group: ownerGroup?.name || "Deleted",
      }}
    />
  );
}
